import type { WeekState } from './types';

export interface WeekBackup {
  exportedAt: string;
  week: WeekState;
}

export function buildWeekBackup(week: WeekState): WeekBackup {
  return {
    exportedAt: new Date().toISOString(),
    week: JSON.parse(JSON.stringify(week)) as WeekState,
  };
}

export function downloadWeekBackup(week: WeekState): void {
  const backup = buildWeekBackup(week);
  const blob = new Blob([JSON.stringify(backup, null, 2)], {
    type: 'application/json',
  });
  const url = URL.createObjectURL(blob);
  const a = document.createElement('a');
  a.href = url;
  a.download = `pickem-${week.weekKey}.json`;
  a.click();
  URL.revokeObjectURL(url);
}
